import styled from "styled-components";

export const Header = styled.header`
  padding: 17px;
  border-bottom: 1px solid #eee;
  margin-bottom: 32px;
  background: ${({ $background }) => $background};

  @media screen and (min-width: 768px) {
    padding: 17px 0;
  }
`;

export const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LanguageSwitcher = styled.button`
  border-radius: 5px;
  border: 1px solid #eee;
  background: #fff;
  color: #333;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  width: 100%;
  cursor: pointer;
  text-transform: capitalize;
  max-width: 200px;

  svg {
    width: 16px;
    height: 16px;
    fill: #333;
  }

  @media screen and (min-width: 1024px) {
    background: transparent;
    border: 1px solid #666;
    width: auto;
    padding: 8px 16px;
    color: #fff;

    svg {
      fill: #fff;
    }
  }
`;
